<div *ngIf="_.visible" animatedSize class="content" (click)="_.reload()">
  <div class="header-container">
    <div class="rv-rows large outer">
      <div class="rv-flex">
        <div class="message">
          <h1 class="rv-title-01">A new version of Rivet is available</h1>
          <h1 class="rv-title-01 rv-low-contrast">Click to update</h1>
        </div>
        <button
          rivButton
          [variant]="'ghost'"
          [size]="'large'"
          class="close"
          title="Close"
          type="button"
          (click)="_.reload()"
          [icon]="'X'"
        ></button>
      </div>
      <ng-content select=".header-extras"></ng-content>
    </div>
    <ng-content select="[header-bottom]"></ng-content>
  </div>
</div>
